module.exports = __webpack_public_path__ + "img/icon_prev.a4641d52.svg";